import React from 'react';
import { Col } from 'react-bootstrap5';

export default function CpaInfo() {
  return (
    <Col md="6" className="main">
      <div className="fw-light small">
        What Are Your Specific Coaching Goals? What Are Your Current &lsquo;Coordinates&rsquo;?
        Take Your Talent Assessment. Check Recommended LeggUP Development Plans.
        Start Your LeggUP Membership.
      </div>
    </Col>
  );
}
